import {IComponentController} from "angular";

export class SmsSettingsPreview implements IComponentController {
    public smsPreviewData: string;
    public isLoading: boolean;

    public static instance = {
        template: require('./sms-settings-preview.html'),
        controller: SmsSettingsPreview,
        bindings: {
            smsPreviewData: '=',
            isLoading: '='
        }
    };
}
